export { default as Square3Stack3DIcon } from './Square3Stack3DIcon';
